import { toBool } from 'vopay';
import { usePermissions } from '@/providers/Permissions.provider';
import { useClientData } from '@/providers/ClientData.provider';

/**
 * Single source of truth for whether the current account + user may use Transaction Approval.
 *
 * Combines the account entitlement (`TransactionApprovalWorkflowEnabled` from client data) with
 * the user permission (`ViewTransactionApprovalWorkflow`). Callers gate their fetches on this so
 * non-entitled accounts never hit the approval endpoints — which otherwise respond with
 * "This operation is not currently enabled for your account" and pollute Datadog RUM.
 */
export default function useTransactionApprovalAccess(): boolean {
  const { permissions } = usePermissions();

  const {
    response: { TransactionApprovalWorkflowEnabled },
  } = useClientData();

  return !!permissions.ViewTransactionApprovalWorkflow && toBool(TransactionApprovalWorkflowEnabled);
}
